import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import toggleStylesheet from "./helpers/toggleStylesheet";
import Routes from "./routes";

import { useSelector } from "react-redux";

import "react-datetime/css/react-datetime.css";
import "react-image-lightbox/style.css";

import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import { PrimeReactProvider } from 'primereact/api';

const App = () => {
  const settings = useSelector((state) => state.settingsReducer);
  const [isLoaded, setIsLoaded] = useState(false);

  const setStylesheetMode = (mode) => {
    setIsLoaded(false);

    toggleStylesheet({ isDark: settings.isDark }, () => setIsLoaded(true));
  };

  useEffect(() => {
    setStylesheetMode("isDark");
    // eslint-disable-next-line
  }, [settings.isDark]);

  return (
    <PrimeReactProvider value={{ ripple: true, inputStyle: "outlined" }}>
      <Router basename={process.env.PUBLIC_URL}>
        <Routes />
      </Router>
    </PrimeReactProvider>
  );
};

export default App;
